import styled from "@emotion/styled";
import {BaseCheckbox} from "views/components/form/checkbox.component";

export const RadioButton = styled(BaseCheckbox)``;

RadioButton.defaultProps = {
	type: "radio",
};
